import { HomeIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { useEmbedMode } from "../../layouts/EmbedLayout";

const DashboardButton = ({ serviceType }) => {
  // Partner-iframe users must stay within the scope handed to them via
  // the embed token — the simulator owns the "Back to <org>" navigation.
  // Hide this dashboard link entirely when rendered inside an embed.
  const { isEmbed } = useEmbedMode();
  if (isEmbed) return null;

  return (
    <Link
      to={
        serviceType == "gstin"
          ? "/gstin"
          : serviceType == "tds"
          ? "/tds"
          : "/income-tax"
      }
      className="group flex items-center gap-3 px-4 py-3 rounded-lg
                   bg-gray-50/50 hover:bg-indigo-50
                   border border-gray-200/50 hover:border-indigo-200
                   text-gray-600 hover:text-indigo-700
                   transition-all duration-200 ease-out
                   hover:shadow-sm
                   exempt-from-readonly mb-4 "
    >
      <HomeIcon className="w-5 h-5 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200" />
      <span className="font-medium text-sm">Dashboard</span>
    </Link>
  );
};

export default DashboardButton;
